import React, { useState, useCallback } from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import AdminLayout from '../../../components/Admin/Layout/AdminLayout';
import SettingsLayout from '../../../components/Admin/Settings/SettingsLayout';
import SettingsManagement from '../../../components/Admin/Settings/SettingsManagement';

/**
 * Payment Accounts Settings Page
 *
 * Manages UPI, bank accounts, card machines, and cash counter settings.
 * Action buttons are rendered in the sticky header.
 */
export default function PaymentAccountsPage() {
  const [componentActions, setComponentActions] = useState(null);

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  // Action buttons for the header
  const headerActions = componentActions ? (
    <>
      <button
        onClick={componentActions.onAdd}
        className="px-3 py-1.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium"
      >
        <Plus size={16} />
        Add Account
      </button>
      <button
        onClick={componentActions.onRefresh}
        className="p-1.5 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 border border-slate-200"
      >
        <RefreshCw size={16} />
      </button>
    </>
  ) : null;

  return (
    <AdminLayout>
      <SettingsLayout actions={headerActions}>
        <SettingsManagement renderActions={handleActionsReady} />
      </SettingsLayout>
    </AdminLayout>
  );
}
